import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import DIRECTV_GO from '~/assets/DIRECTV_GO_LOGO_HORIZONTAL_RGB.svg';
import logoSky from '~/assets/log-SKY.svg';
import logoVrio from '~/assets/VrioFaq.png';
import { signedRequest, signOutRequest } from '~/store/ducks/auth/actions';
import { categoriaRequest } from '~/store/ducks/common/actions';
import { multipleLanguageRequest } from '~/store/ducks/language/actions';
import { ApplicationState } from '../../store';
import { HeaderC } from './styles';

interface DispatchProps {
  signedRequest(): void;
  categoriaRequest(company: any): void;
  multipleLanguageRequest(language: string): void;
  signOutRequest(): void;
}

type Props = DispatchProps;

class Header extends Component<Props> {
  state = {
    // @ts-ignore
    languages: {
      EMPRODUCAO: 'EM PRODUÇÃO',
    },
    usuario: '',
    senha: '',
    seq: '',
    adap: [],
    // @ts-ignore
    isleitura: false,
  };

  componentDidMount() {
    const {
      signedRequest,
      multipleLanguageRequest,
      //@ts-ignore
      company,
      categoriaRequest,
    } = this.props;
    multipleLanguageRequest('ptbr');
    signedRequest();
    categoriaRequest(company?.country_company_id);
  }

  setLogo = (company: number) => {
    if (company === 1) {
      return logoSky;
    } else {
      return DIRECTV_GO;
    }
  };

  render() {
    //@ts-ignore
    const { signOutRequest, company } = this.props;
    return (
      <HeaderC className="main-header">
        <nav className="navbar navbar-static-top">
          <div className="container">
            <Link to={`/${company?.path_alias_nm}/home`}>
              <div className="logo-vrio" style={{ cursor: 'pointer' }}>
                <img src={logoVrio} alt="logo Vrio" />
              </div>
            </Link>
            <a
              className="sidebar-toggle"
              data-toggle="push-menu"
              role="button"
            />
          </div>

          <div className="navbar-custom-menu">
            <ul className="nav navbar-nav">
              <li className="dropdown user user-menu" onClick={signOutRequest}>
                <a className="btn btn-flat">Sair</a>
              </li>
              <li
                className="dropdown"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: 20,
                }}
              >
                <div>
                  {company?.country_company_id ? (
                    <img
                      style={{ height: 30, objectFit: 'contain' }}
                      src={this.setLogo(company.country_company_id)}
                      alt={`logo ${company?.company?.company_name?.toUpperCase()}`}
                    />
                  ) : (
                    ''
                  )}
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </HeaderC>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  infoHeader: state.user.infoHeader,
  company: state.auth.company,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators(
    {
      signedRequest,
      multipleLanguageRequest,
      signOutRequest,
      categoriaRequest,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
